var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-fullscreen',
                        view: publicPath + 'sprite.svg#view-icon-fullscreen',
                        viewBox: '0 0 533.333 533.333',
                        title: 'icons/fonctions/fullscreen',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };